import { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import dateHandlder from "../../../../../helpers/dates-hanlder";
import { dateSpliter } from "../../../../../helpers/dates-hanlder";
import { Group } from "../../../../../types";

const periods = {
  minute: { plural: "minutos", singular: "minuto" },
  hour: { plural: "horas", singular: "hora" },
  day: { plural: "días", singular: "día" },
  week: { plural: "semanas", singular: "semana" },
  month: { plural: "meses", singular: "mes" },
  year: { plural: "años", singular: "año" },
};

interface ComponentProps {
  group: Group
}

const Component = ({ group }: ComponentProps) => {
  const [suscriptionEnded, setSuscriptionEnded] = useState<boolean>();

  const getFechaInscripcion = (date) => {
    const { day, month, year, hours, minutes } = dateHandlder.dateSpliter(date);
    return <span>Cierre de inscripciones: <strong>{day.number}/{month.number}/{year} a las {hours}:{minutes} hs.</strong></span>
  }

  const getPeriod = (duration, unit) => {
    if (unit) {
      return `${duration} ${duration > 1 ? periods[unit].plural : periods[unit].singular
        }`;
    }
    return "";
  };

  // Muestra la fecha de apertura de inscripciones
  const getFechaApertura = (date) => {
    if (!date) return null;
    const { day, month, year, hours, minutes } = dateSpliter(date);
    return `Las inscripciones abren el: ${day.number}/${month.number}/${year} a las ${hours}:${minutes} horas.`;
  };

  // Muestra la fecha de cierre de inscripciones
  const getFechaCierre = (date) => {
    if (!date) return null;
    const { day, month, year, hours, minutes } = dateSpliter(date);
    return `Las inscripciones cierran el: ${day.number}/${month.number}/${year} a las ${hours}:${minutes} horas.`;
  };

  // Texto completo del estado de inscripciones
  const getInscripcionesInfo = () => {
    if (!group) return null;

    const isOpen = group.subscriptions_status === 'open';
    const hasOpeningDate = group.subscriptions_opening_date && new Date(group.subscriptions_opening_date) > new Date();
    const hasClosingDate = group.subscriptions_closing_date && new Date(group.subscriptions_closing_date) > new Date();

    if (isOpen) {
      // Puertas abiertas
      if (hasClosingDate) {
        return getFechaCierre(group.subscriptions_closing_date);
      }
      return 'Inscripciones abiertas';
    } else {
      // Puertas cerradas
      if (hasOpeningDate) {
        return getFechaApertura(group.subscriptions_opening_date);
      }
      return 'Inscripciones cerradas';
    }
  };

  // Memoizar el cálculo de la fecha de cierre para evitar cambios inesperados
  const closingDateToShow = useMemo(() => {
    return group?.subscriptions_closing_date || group?.registration_closing_date;
  }, [group?.subscriptions_closing_date, group?.registration_closing_date]);

  // Memoizar el estado de suscripción para evitar re-renders innecesarios
  useEffect(() => {
    if (!!closingDateToShow) {
      setSuscriptionEnded(
        dateHandlder.isExpired(closingDateToShow)
      );
    } else {
      setSuscriptionEnded(undefined);
    }
  }, [closingDateToShow]);

  // Calcular el estado de inscripciones (no memoizar porque depende de new Date())
  // pero asegurar que se calcule de forma estable durante el render
  const inscripcionesInfo = getInscripcionesInfo();

  // Verificar si ya se mostró el cierre (no memoizar porque depende de new Date())
  const yaSeMostroCierre = (() => {
    const isOpen = group?.subscriptions_status === 'open';
    if (!isOpen || !group?.subscriptions_closing_date) return false;
    const now = new Date();
    const closingDate = new Date(group.subscriptions_closing_date);
    return closingDate > now;
  })();

  return (
    <div style={{ minHeight: '60px' }}>
      {inscripcionesInfo && (
        <div style={{ fontSize: 14, textAlign: 'center' }}>
          {inscripcionesInfo}
        </div>
      )}
      {group?.group_type === "membership" ? (
        <div style={{ fontSize: 14, textAlign: 'center' }}>Sin tiempo mínimo de permanencia, cancelas cuando quieras!</div>
      ) : group?.recorded ? (
        <div style={{ fontSize: 14, textAlign: 'center' }}>Tendrás acceso a todos los contenidos del Curso de forma inmediata!</div>
      ) : (
        <>
          {/* Solo mostrar fecha de cierre si no se mostró ya en inscripcionesInfo */}
          {!yaSeMostroCierre && closingDateToShow && (
            <div style={{ fontSize: 14, textAlign: 'center' }}><i>{suscriptionEnded ? 'Inscripción finalizada.' : getFechaInscripcion(closingDateToShow)}  </i></div>
          )}
          <div style={{ fontSize: 14, textAlign: 'center' }}><i>Duración del taller: <strong>{getPeriod(group?.duration, group?.duration_unit)}.</strong></i></div>
        </>
      )}
    </div>
  )
}

const state = ({ groupStore }) => {
  const { data: group } = groupStore.group;

  return {
    group,
  };
};

export default connect(state)(Component);
